import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { CardBack } from '@sorare/core/src/components/card/Back';
import { formatScarcity } from '@sorare/core/src/lib/cards';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Wrapper = styled(Horizontal)`
  height: 50px;
  position: relative;
  border-top-left-radius: var(--double-unit);
  padding: var(--intermediate-unit) var(--triple-unit);
  border-top-right-radius: var(--double-unit);
  background: rgba(var(--c-rgb-common), 0.2);
  clip-path: inset(-100% 0 0 0);

  &.limited {
    background: rgba(var(--c-rgb-limited), 0.2);
  }

  &.rare {
    background: rgba(var(--c-rgb-rare), 0.2);
  }

  &.super_rare {
    background: rgba(var(--c-rgb-superRare), 0.2);
  }

  &.unique {
    background: rgba(var(--c-rgb-unique), 0.2);
  }

  @media ${tabletAndAbove} {
    justify-content: center;
    padding: var(--intermediate-unit);
  }
`;

const CardBackWrapper = styled.div`
  width: 32px;
  height: 32px;
  aspect-ratio: var(--card-aspect-ratio);
  position: relative;

  @media ${tabletAndAbove} {
    width: 110px;
    height: 75px;
  }
`;

const BottomCardBack = styled(CardBack)`
  transform: rotate(9deg);
  position: absolute;
  top: 5px;
  right: 4px;
  width: 15px;

  @media ${tabletAndAbove} {
    top: 10px;
    right: 4px;
    width: 45px;
  }
`;

const TopCardBack = styled(CardBack)`
  transform: rotate(-16deg);
  position: absolute;
  right: 15px;
  width: 20px;
  box-shadow: 0px 2px 9px 0px #000000;

  @media ${tabletAndAbove} {
    right: 24px;
    width: 56px;
  }
`;

type Props = {
  rarity: Rarity | 'mix';
};

export const CompetitionHeader = ({ rarity }: Props) => {
  return (
    <Wrapper className={rarity}>
      <CardBackWrapper>
        <BottomCardBack
          rarity={rarity === 'mix' ? Rarity.common : rarity}
          season="2025"
        />
        <TopCardBack
          rarity={rarity === 'mix' ? Rarity.common : rarity}
          season="2025"
        />
      </CardBackWrapper>
      <BrandM>{formatScarcity(rarity)}</BrandM>
    </Wrapper>
  );
};
